import { render, staticRenderFns } from "./scoreEntryGrade.vue?vue&type=template&id=020a7695&scoped=true"
import script from "./scoreEntryGrade.vue?vue&type=script&lang=js"
export * from "./scoreEntryGrade.vue?vue&type=script&lang=js"
import style0 from "./scoreEntryGrade.vue?vue&type=style&index=0&id=020a7695&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a7695",
  null
  
)

export default component.exports